import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "h-full min-h-screen md:flex" }
const _hoisted_3 = { class: "p-6 mb-0 md:hidden" }
const _hoisted_4 = { class: "px-4 pt-4 pb-5 mx-auto border rounded-lg border-clay-300 bg-clay-100" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "hidden md:flex md:shrink-0" }
const _hoisted_7 = { class: "pt-6 pb-12 sm:flex sm:flex-col md:w-54 bg-white" }
const _hoisted_8 = { class: "flex flex-col flex-1 min-h-0" }
const _hoisted_9 = { class: "flex flex-col flex-1 pt-5 pb-4 overflow-y-auto" }
const _hoisted_10 = {
  "aria-label": "Sidebar",
  class: "grid grid-cols-2 gap-4 md:grid-cols-2 sm:grid-cols-3 lg:grid-cols-1 lg:gap-0 md:space-y-2"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "flex-col flex-1 min-w-0 overflow-visible md:flex sm:px-6 lg:px-4" }
const _hoisted_13 = { class: "relative z-0 flex flex-1 mb-12 overflow-visible bg-white" }
const _hoisted_14 = { class: "relative z-0 flex-1 pt-6 focus:outline-hidden xl:order-last" }
const _hoisted_15 = { class: "relative inset-0 px-4 pb-6 sm:px-6 lg:px-8" }
const _hoisted_16 = { class: "h-full pb-8 bg-clay-50 rounded-2xl" }
const _hoisted_17 = { class: "pt-5 pl-4 pr-4 contentful-tab" }
const _hoisted_18 = { class: "guidesTab md:h-full" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "mx-auto overflow-hidden transition-all transform divide-y divide-gray-200 max-w-7xl" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "grid gap-6 py-2 mb-8 text-sm text-gray-800 sm:grid-cols-12" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = { class: "mt-2 text-base font-semibold leading-6 text-gray-600" }

import { computed, onMounted, Ref, ref } from "vue";
import { client } from "@/shared";
// @ts-ignore
import Paginate from "vuejs-paginate-next";
import {
  GetTalentFavorites,
  GetTalentFavoritesResponse,
  GuideTypeWithCount
} from "@/dtos";
import ShowCard from "../Guides/Shows/ShowCard.vue";
import CharacterCard from "../Guides/Characters/CharacterCard.vue";
import MonologueCard from "../Guides/Monologues/MonologueCard.vue";
import TalentProfileCard from "../Talent/TalentProfileCard.vue";
import SceneCard from "../Guides/Scenes/SceneCard.vue";
import SongCard from "../Guides/Songs/SongCard.vue";
import WriterCard from "../Guides/Writers/WriterCard.vue";
import TheatreCompanyCard from "../TheatreCompanies/TheatreCompanyCard.vue";
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";
import _ from "lodash";
import CollegeProgramCard from "../CollegePrograms/CollegeProgramCard.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TalentFavorites',
  props: {
  url: {
    type: String,
    required: true
  },
  type: {
    type: String,
    default: "Shows"
  },
  name: {
    type: String
  }
},
  setup(__props) {

// @ts-ignore
const props = __props;

const resultsSection = ref(null);
const getFavoritesResponse = ref<GetTalentFavoritesResponse>({});
const results: any = ref<[]>([]);
const otherResults = ref<Array<GuideTypeWithCount>>([]);
const queryCategory = ref("");
const request: Ref<GetTalentFavorites> = ref({});
const isRetrieving = ref(false);

onMounted(async () => {
  let category = "Shows";
  queryCategory.value = getValidCategoryOrDefault(decodeURIComponent(category));
  await getFannedItemsByCategory(true);
});

const getFannedItemsByCategory = async (isPageLoad: boolean = false) => {
  if (!isPageLoad) {
    resultsSection.value.scrollIntoView({ behavior: "smooth" });
  }

  if (isPageLoad) {
    resetPagination();
  }

  isRetrieving.value = true;

  request.value.url = props.url;
  request.value.guideType = queryCategory.value;
  console.log("clicked");

  await client
    .get<GetTalentFavoritesResponse>(new GetTalentFavorites(request.value))
    .then(res => {
      getFavoritesResponse.value = res;
      queryCategory.value = res.guideType;
      results.value = res.results;
      otherResults.value = res.guideTypesWithCounts;
      isRetrieving.value = false;
    });
};

let hasResults = computed(() => {
  return results.value?.length > 0;
});

const onOtherResultsClicked = async (clickedCategory: string) => {
  queryCategory.value = clickedCategory;
  resetPagination();
  await getFannedItemsByCategory();
};

const paginationClickHandler = async (pageNum: any) => {
  request.value.currentPage = pageNum;
  await getFannedItemsByCategory();
};

const resetPagination = () => {
  request.value.currentPage = 1;
};

const getPageCount = () => {
  return Math.ceil(getFavoritesResponse.value.totalResults / 12);
};

let getClassForCard = computed(() => {
  let fourCol = "sm:col-span-6 col-span-12 md:col-span-3";
  let threeCol = "md:col-span-4 sm:col-span-6 col-span-12";
  let twoCol = "sm:col-span-6 col-span-12";

  switch (queryCategory.value) {
    case "Shows":
      return threeCol;
    case "Companies":
    case "College Programs":
      return threeCol;
    case "Talent profiles":
      return threeCol;
    default:
      return twoCol;
  }
});

const getValidCategoryOrDefault = (incomingCategory: string) => {
  let validCategories = {
    Shows: ["Shows", "shows"],
    Characters: ["Characters", "characters"],
    "Playwrights & composers": [
      "Playwrights & composers",
      "Writers",
      "writers"
    ],
    Songs: ["Songs", "songs"],
    Monologues: ["Monologues", "monologues"],
    Scenes: ["Scenes", "scenes"],
    "Talent profiles": [
      "Talent profiles",
      "talent profiles",
      "Talent",
      "talent"
    ],
    Companies: ["Companies", "companies", "theatre companies", "theatre"],
    "College Programs": [
      "College programs",
      "College Programs",
      "college",
      "programs"
    ]
  };

  let category = _.findKey(validCategories, function(cat) {
    return cat.includes(incomingCategory);
  });

  return category ?? "Shows";
};

let nextHtml = `<span class="hidden md:inline-block">Next</span>
                        <svg class="w-5 h-5 ml-3 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                        </svg>`;

let prevHtml = `<svg class="w-5 h-5 mr-3 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clip-rule="evenodd" />
                        </svg>
                        <span class="hidden md:inline-block">Previous</span>`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      ref_key: "resultsSection",
      ref: resultsSection,
      class: "max-w-6xl mx-auto"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "pb-2 text-sm font-semibold tracking-wide uppercase text-clay-800" }, " Favorites by Category ", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("label", {
                for: "mobile-category-select",
                class: "sr-only"
              }, "Select a category", -1)),
              _withDirectives(_createElementVNode("select", {
                id: "mobile-category-select",
                name: "mobile-category-select",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryCategory).value = $event)),
                onChange: _cache[1] || (_cache[1] = ($event: any) => (onOtherResultsClicked(queryCategory.value))),
                class: "block w-full px-4 py-2 mt-1 text-sm border rounded-md border-clay-300 focus:border-clay-500 focus:ring-clay-500 bg-clay-50 text-clay-900"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherResults.value, (result) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: result.guideType,
                    value: result.guideType
                  }, _toDisplayString(result.guideType) + " (" + _toDisplayString(isRetrieving.value ? "..." : result.totalResults) + ") ", 9, _hoisted_5))
                }), 128))
              ], 544), [
                [_vModelSelect, queryCategory.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex items-center px-4 shrink-0" }, null, -1)),
                  _createElementVNode("nav", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherResults.value, (result) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: result.guideType,
                        class: "space-y-5 text-clay-700"
                      }, [
                        _createElementVNode("a", {
                          onClick: _withModifiers(($event: any) => (onOtherResultsClicked(result.guideType)), ["prevent"]),
                          class: _normalizeClass([
                          result.guideType === queryCategory.value
                            ? 'text-clay-900 bg-slate-200 font-bold'
                            : ''
                        , "items-center block min-w-full px-4 py-2 text-sm capitalize rounded-md sm:flex text-clay-800 bg-clay-100 group hover:text-clay-700 hover:bg-clay-50"])
                        }, [
                          _createTextVNode(_toDisplayString(result.guideType) + " (", 1),
                          _createElementVNode("em", null, _toDisplayString(isRetrieving.value ? "..." : result.totalResults), 1),
                          _cache[5] || (_cache[5] = _createTextVNode(") "))
                        ], 10, _hoisted_11)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        (results.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                (isRetrieving.value)
                                  ? (_openBlock(), _createBlock(SkeletonCard, {
                                      key: 0,
                                      class: "mt-3",
                                      "card-style": "long",
                                      "num-of-cards": 4
                                    }))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                      _createElementVNode("div", _hoisted_22, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, (result) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: result.id,
                                            class: _normalizeClass([_unref(getClassForCard), "relative flex items-center space-x-3 search-query-cards"])
                                          }, [
                                            (queryCategory.value === 'Shows')
                                              ? (_openBlock(), _createBlock(ShowCard, {
                                                  key: 0,
                                                  show: result
                                                }, null, 8, ["show"]))
                                              : (queryCategory.value === 'Characters')
                                                ? (_openBlock(), _createBlock(CharacterCard, {
                                                    key: 1,
                                                    character: result
                                                  }, null, 8, ["character"]))
                                                : (queryCategory.value === 'Monologues')
                                                  ? (_openBlock(), _createBlock(MonologueCard, {
                                                      key: 2,
                                                      monologue: result
                                                    }, null, 8, ["monologue"]))
                                                  : (queryCategory.value === 'Scenes')
                                                    ? (_openBlock(), _createBlock(SceneCard, {
                                                        key: 3,
                                                        scene: result
                                                      }, null, 8, ["scene"]))
                                                    : (queryCategory.value === 'Songs')
                                                      ? (_openBlock(), _createBlock(SongCard, {
                                                          key: 4,
                                                          song: result
                                                        }, null, 8, ["song"]))
                                                      : (
                                      queryCategory.value ===
                                        'Playwrights & composers'
                                    )
                                                        ? (_openBlock(), _createBlock(WriterCard, {
                                                            key: 5,
                                                            writer: result
                                                          }, null, 8, ["writer"]))
                                                        : (queryCategory.value === 'Companies')
                                                          ? (_openBlock(), _createBlock(TheatreCompanyCard, {
                                                              key: 6,
                                                              company: result
                                                            }, null, 8, ["company"]))
                                                          : (
                                      queryCategory.value === 'Talent profiles'
                                    )
                                                            ? (_openBlock(), _createBlock(TalentProfileCard, {
                                                                key: 7,
                                                                talent: result
                                                              }, null, 8, ["talent"]))
                                                            : (
                                      queryCategory.value === 'College Programs'
                                    )
                                                              ? (_openBlock(), _createBlock(CollegeProgramCard, {
                                                                  key: 8,
                                                                  program: result
                                                                }, null, 8, ["program"]))
                                                              : _createCommentVNode("", true)
                                          ], 2))
                                        }), 128))
                                      ]),
                                      _createVNode(_unref(Paginate), {
                                        modelValue: getFavoritesResponse.value.currentPage,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((getFavoritesResponse.value.currentPage) = $event)),
                                        "active-class": 
                                  'border-electric-500 text-electric-600 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium'
                                ,
                                        "click-handler": paginationClickHandler,
                                        "container-class": 
                                  'border-t border-gray-200 px-4 flex items-center justify-between sm:px-0'
                                ,
                                        "margin-pages": 2,
                                        "next-class": 
                                  '-mt-px w-0 flex-1 flex justify-end'
                                ,
                                        "next-link-class": 
                                  'border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-sm font-medium text-clay-800 hover:text-gray-700 hover:border-clay-500'
                                ,
                                        "next-text": _unref(nextHtml),
                                        "page-class": 
                                  'border-transparent text-clay-800 hover:text-gray-700 hover:border-clay-500 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium'
                                ,
                                        "page-count": getPageCount(),
                                        "page-range": 3,
                                        "prev-class": '-mt-px w-0 flex-1 flex',
                                        "prev-link-class": 
                                  'border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-sm font-medium text-clay-800 hover:text-gray-700 hover:border-clay-500'
                                ,
                                        "prev-text": _unref(prevHtml)
                                      }, null, 8, ["modelValue", "next-text", "page-count", "prev-text"])
                                    ]))
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("h2", _hoisted_25, _toDisplayString(__props.name) + " has not added any favorites to this category just yet. ", 1)
                                ])
                              ])
                            ]))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ], 512)
  ]))
}
}

})